export default function defineProperty(obj, prop, val) {
    Object.defineProperty(obj, prop, val);
};
